import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    icon: {
        m: 0,
    },
}
